import React from "react";

import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Bet } from "@models";

export const MaxCoefficient = observer(function MaxCoefficient(props: {
	bet: Bet;
}) {
	const { t } = useTranslation("mybets");
	const { bet } = props;

	return (
		<div className="bet__details__row">
			<div className="bet__details__col">
				{t("ITEM.ADDITIONAL_MAX_COEFFICIENT")}
			</div>
			<div className="bet__details__col">
				{bet.maxCoefficient.toFixed(2)}
			</div>
		</div>
	);
});
